<template>
    <div class="betslip-app-wrapper pull-right">
      <sp-betslip></sp-betslip>
    </div>
</template>

<script>

export default {
  name: 'BetslipBox',
};
</script>
